import store from "@/store.js"
import moment from 'moment'

export function loginFromSession()
{
  const expires = sessionStorage.getItem("expires");
  const now = moment().unix()
  const name = sessionStorage.getItem("login");
  const token = sessionStorage.getItem("token");

  return expires && name && token && now < expires ? name : undefined;
}

export function logoutWhenExpired()
{
  const expires = sessionStorage.getItem("expires");
  const now = Math.floor(Date.now() / 1000);

  if (expires & now < Number(expires))
  {
    setTimeout(function() { store.dispatch("logout") }, (Number(expires)-now)*1000);
  }
}
